import IconPencil from "assets/img/icon-pencil.svg?react"
import IconTrashBin from "assets/img/icon-trash-bin.svg?react"

import React, { FC, useState } from "react"
import { useTranslation } from "react-i18next"

import { Flex } from "components/Flex"
import Button from "components/Button/Button"
import { getTranslation } from "utils/translations"
import FreightUnitModal from "./FreightUnitModal"
import Measurements from "components/Measurements/Measurements"
import { IGetFreightUnit } from "models/Asset"
import { useTenantSettings } from "stores/tenantSettings"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"

interface IFreightUnitsItemProps {
    freightUnit: IGetFreightUnit
    onChange?(freightUnit: IGetFreightUnit): void
    onDelete?(): void
}

const FreightUnitsItem: FC<React.PropsWithChildren<IFreightUnitsItemProps>> = ({
    freightUnit,
    onChange,
    onDelete,
}) => {
    const { t } = useTranslation()
    const [showFreightUnitModal, setShowFreightUnitModal] = useState(false)
    const { tenantPrimaryLanguageIsoCode } = useTenantSettings()

    return (
        <>
            <Flex
                alignItems="center"
                justifyContent="space-between"
                gap="1.6rem">
                <div className="mb-half">
                    <FlexibleContent
                        text={getTranslation(freightUnit.translations, tenantPrimaryLanguageIsoCode)}
                    />
                </div>
                {!!onChange &&
                    <Flex alignItems="center" gap="1.6rem">
                        <Button
                            round
                            theme="grey"
                            icon={<IconPencil />}
                            ariaLabel={t('common.edit')}
                            onClick={() => setShowFreightUnitModal(true)}>
                        </Button>
                        <Button
                            round
                            theme="grey"
                            icon={<IconTrashBin />}
                            ariaLabel={t('common.delete')}
                            onClick={onDelete}>
                        </Button>
                    </Flex>
                }
            </Flex>
            <Measurements
                measurementSystemId={freightUnit.measurementSystemId}
                dimension1={freightUnit.dimension1}
                dimension2={freightUnit.dimension2}
                dimension3={freightUnit.dimension3}
                volume={freightUnit.volume}
                weight={freightUnit.weight}
            />
            {showFreightUnitModal && !!onChange &&
                <FreightUnitModal
                    freightUnit={freightUnit}
                    onSave={onChange}
                    onClose={() => setShowFreightUnitModal(false)}
                />
            }
        </>
    )
}

export default FreightUnitsItem
